var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 2,
    stroke: "#626569",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9164 11.5C14.4437 11.5 13.2498 12.5074 13.2498 13.75C13.2498 14.9926 14.5969 15.7217 15.9164 16C17.236 16.2783 18.5831 17.0074 18.5831 18.25C18.5831 19.4926 17.3892 20.5 15.9164 20.5M15.9164 11.5C17.3892 11.5 18.2232 12.2329 18.5831 13M15.9164 11.5V10M15.9164 20.5C14.4437 20.5 13.5122 19.7223 13.2498 19M15.9164 20.5V22",
    stroke: "#EC5341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81694 5.06694C8.06102 4.82286 8.06102 4.42714 7.81694 4.18306C7.57286 3.93898 7.17714 3.93898 6.93306 4.18306L4.43306 6.68306C4.18898 6.92714 4.18898 7.32286 4.43306 7.56694C4.67714 7.81102 5.07286 7.81102 5.31694 7.56694L7.81694 5.06694ZM10.7336 5.48361C10.9777 5.23953 10.9777 4.8438 10.7336 4.59973C10.4895 4.35565 10.0938 4.35565 9.84972 4.59973L4.84973 9.59972C4.60565 9.8438 4.60565 10.2395 4.84973 10.4836C5.0938 10.7277 5.48953 10.7277 5.73361 10.4836L10.7336 5.48361Z",
    fill: "#FFA89E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.7a71652afebed6ecd065c609ddbb9a99.svg";
export { ForwardRef as ReactComponent };